import { render } from "./trip-image.vue?vue&type=template&id=951946f2"
import script from "./trip-image.vue?vue&type=script&lang=js"
export * from "./trip-image.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__